export default {"id":"icon-symbol-profile"}